module.exports = __webpack_public_path__ + "static/media/external-link-icon-2.e512bb5d.svg";